function navigationScripts(){
	(function() {

		'use strict';

		const ClickyMenus = function( menu ) {

			// DOM element(s)
			let container = menu.parentElement,
			currentMenuItem,
			i,
			len;

			this.init = function() {
			menuSetup();
			document.addEventListener( 'click', closeOpenMenu );
			}


			/*===================================================
			=            Menu Open / Close Functions            =
			===================================================*/
			function toggleOnMenuClick( e ) {

				const button = e.currentTarget;
				
				let submenuListItem = button.parentElement.id;
				
				// close open menu if there is one
				if ( currentMenuItem && button !== currentMenuItem ) {
					toggleSubmenu( currentMenuItem );
				}

				toggleSubmenu( button );

			};

			function toggleSubmenu( button ) {

				const submenu = document.getElementById( button.getAttribute( 'aria-controls' ) );
				

				if ( 'true' === button.getAttribute( 'aria-expanded' ) ) {

					button.setAttribute( 'aria-expanded', false );
					submenu.setAttribute( 'aria-hidden', true );
					currentMenuItem = false;

				} else {

					button.setAttribute( 'aria-expanded', true );
					submenu.setAttribute( 'aria-hidden', false );
					preventOffScreenSubmenu( submenu );
					currentMenuItem = button;
				}

			};

			function preventOffScreenSubmenu( submenu ) {

			const   screenWidth = window.innerWidth ||
						document.documentElement.clientWidth ||
						document.body.clientWidth,
				parent = submenu.offsetParent,
				menuLeftEdge = parent.getBoundingClientRect().left,
				menuRightEdge = menuLeftEdge + submenu.offsetWidth;

			if ( menuRightEdge + 32 > screenWidth ) { // adding 32 so it's not too close
				submenu.classList.add( 'sub-menu--right' );
			}

			}

			function closeOnEscKey(e) {
			if( 27 === e.keyCode ) {

				// we're in a submenu item
				if( null !== e.target.closest('ul[aria-hidden="false"]') ) {
				currentMenuItem.focus();
				toggleSubmenu( currentMenuItem );

				// we're on a parent item
				} else if ( 'true' === e.target.getAttribute('aria-expanded') ) {
				toggleSubmenu( currentMenuItem );
				}

			}

			}

			function closeOpenMenu( e ) {

			if ( currentMenuItem && ! e.target.closest( '#' + container.id ) ) {
				toggleSubmenu( currentMenuItem );
			}

			};

			/*===========================================================
			=            Modify Menu Markup & Bind Listeners            =
			=============================================================*/
			function menuSetup() {

			menu.classList.remove('no-js');

			menu.querySelectorAll('ul').forEach( ( submenu ) => {

				const menuItem = submenu.parentElement;

				if ( 'undefined' !== typeof submenu ) {

				let button = convertLinkToButton( menuItem );
				setUpAria( submenu, button );

				// bind event listener to button
				button.addEventListener( 'click', toggleOnMenuClick );
				menu.addEventListener( 'keyup', closeOnEscKey );

				}

			});

			};

			/**
			 * Why do this? See https://justmarkup.com/articles/2019-01-21-the-link-to-button-enhancement/
			 */
			function convertLinkToButton( menuItem ) {

			const   link = menuItem.getElementsByTagName( 'a' )[0],
				linkHTML = link.innerHTML,
				linkAtts = link.attributes,
				button = document.createElement( 'button' );

			if( null !== link ) {

				// set button content and attributes
				button.innerHTML = linkHTML.trim();
				for( i = 0, len = linkAtts.length; i < len; i++ ) {
				let attr = linkAtts[i];
				if( 'href' !== attr.name ) {
					button.setAttribute( attr.name, attr.value );
				}
				}
				
				var plusIcon = document.createElement('i');
				plusIcon.classList.add('fa-solid', 'fa-plus')

				var minusIcon = document.createElement('i');
				minusIcon.classList.add('fa-solid', 'fa-minus')

				menuItem.replaceChild( button, link );

				button.append(plusIcon);

			}

			return button;

			}

			function setUpAria( submenu, button ) {

			const submenuId = submenu.getAttribute( 'id' );

			let id;
			if( null === submenuId ) {
				id = button.textContent.trim().replace(/\s+/g, '-').toLowerCase() + '-submenu';
			} else {
				id = menuItemId + '-submenu';
			}

			// set button ARIA
			button.setAttribute( 'aria-controls', id );
			button.setAttribute( 'aria-expanded', false );

			// set submenu ARIA
			submenu.setAttribute( 'id', id );
			submenu.setAttribute( 'aria-hidden', true );

			}

		}

		/* Create a ClickMenus object and initiate menu for any menu with .clicky-menu class */
		document.addEventListener('DOMContentLoaded', function(){
			const menus = document.querySelectorAll( '.clicky-menu' );

			menus.forEach( menu => {

			let clickyMenu = new ClickyMenus(menu);
			clickyMenu.init();

			});
		});
	}());

	window.onload = function() {
		var headerMain = document.querySelector('#site-header');
		var myHamburger = document.querySelectorAll('.hamburger')[0];
		var closeNavMenu = document.querySelectorAll('.closeNavMenu')[0];
		var subMenu = document.querySelector('.clicky-menu ul');
		var activeMenu = document.querySelector('.menu-item-has-children button');
		var navElements = document.querySelectorAll('.header-main, #site-navigation, .navigation-container, .modal, .header-top-bar' );

		var searchOpen = document.querySelector('#search-button');
		var searchClose = document.querySelector('.submit .close');
		var mobileSearch = document.querySelector('.mobile-search');

		
		function openClose(option){
			for ( const element of navElements ){
				if (option == 'close'){
					element.classList.remove('menuOpen');
				} else {
					element.classList.add('menuOpen');
				}
			}
		}
		
		if ( myHamburger && closeNavMenu ) {
			window.addEventListener('resize', function(){
				if ( window.innerWidth >= 992 ) {
					openClose('close');
				} else {
					if(subMenu){
						subMenu.setAttribute( 'aria-hidden', true );
					}
					if (activeMenu){
						activeMenu.setAttribute( 'aria-expanded', false );
					}
				}
			});

			myHamburger.addEventListener('click', function() {
				openClose('open');
			});

			closeNavMenu.addEventListener('click', function() {
				openClose('close');
			});

			searchOpen.addEventListener('click', function () {
				openClose('close');
				
				if (mobileSearch.classList.contains('hidden')) {
					headerMain.classList.add('search-open');
					mobileSearch.classList.remove('hidden');
					setTimeout(function () {
						mobileSearch.classList.remove('visuallyhidden');

					}, 10);
				} else {
					headerMain.classList.remove('search-open');
					mobileSearch.classList.add('visuallyhidden');    
					mobileSearch.addEventListener('transitionend', function(e) {
						mobileSearch.classList.add('hidden');
					}, {
						capture: false,
						once: true,
						passive: false
					});
				}
				
			}, false);
			
			searchClose.addEventListener('click', function () {
				if (mobileSearch.classList.contains('hidden')) {
					headerMain.classList.add('search-open');
					mobileSearch.classList.remove('hidden');
					setTimeout(function () {
						mobileSearch.classList.remove('visuallyhidden');
					}, 10);
				} else {
					headerMain.classList.remove('search-open');
					mobileSearch.classList.add('visuallyhidden');    
					mobileSearch.addEventListener('transitionend', function(e) {
						mobileSearch.classList.add('hidden');
					}, {
						capture: false,
						once: true,
						passive: false
					});
				}
				
			}, false);

			window.addEventListener('resize', function(){
				if ( window.innerWidth >= 1200 ) {
					headerMain.classList.remove('search-open');
					mobileSearch.classList.add('visuallyhidden');    
					mobileSearch.classList.add('hidden');
				} 
			});
		}
	};  
};

export default navigationScripts